import React, { useState, useCallback, useEffect } from "react";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import { imageList } from "../config/imageData";

// 🌟 修复：把 useMemo 移到组件内，这里先用普通变量筛选（组件外不能用 Hooks）
const PERSONAL_ALL_IMAGES_BASE = imageList.filter(img =>
  img.path.includes("Personal")
);

export default function PersonalImage() {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState("All");
  const [photos, setPhotos] = useState(PERSONAL_ALL_IMAGES_BASE);
  const [showCategoryButtons, setShowCategoryButtons] = useState(false);

  // 🌟 修复：useMemo 移到组件内，缓存 Personal 图片列表（部署后防丢失）
  const PERSONAL_ALL_IMAGES = React.useMemo(() =>
    imageList.filter(img => img.path.includes("Personal")),
    [imageList] // 依赖 imageList，变化时重新筛选
  );

  // 强制刷新 photos，解决部署后缓存问题
  useEffect(() => {
    const subCategories = Object.keys({ "All": PERSONAL_ALL_IMAGES_BASE }).filter(key => key !== "All");
    setShowCategoryButtons(subCategories.length > 0);

    // 无分子类时，强制用组件内缓存的图片列表
    if (subCategories.length === 0) {
      setPhotos(PERSONAL_ALL_IMAGES);
    } else {
      setPhotos(PERSONAL_ALL_IMAGES_BASE);
    }
  }, [PERSONAL_ALL_IMAGES]); // 依赖组件内的缓存列表

  const changeCategory = (category) => {
    setActiveCategory(category);
    setPhotos(PERSONAL_ALL_IMAGES || PERSONAL_ALL_IMAGES_BASE);
  };

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  // 基础样式
  const containerStyle = {
    width: "100%",
    padding: "0 20px",
    boxSizing: "border-box",
    marginTop: "20px"
  };

  const btnStyle = {
    padding: "8px 16px",
    margin: "0 8px 15px 0",
    border: "none",
    borderRadius: "4px",
    backgroundColor: "#f0f0f0",
    cursor: "pointer",
    fontSize: "14px",
    fontFamily: "华文细黑"
  };

  const activeBtnStyle = {
    ...btnStyle,
    backgroundColor: "#333",
    color: "white"
  };

  return (
    <div style={containerStyle}>
      {showCategoryButtons && (
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <button
            key="All"
            style={activeBtnStyle}
            onClick={() => changeCategory("All")}
          >
            All
          </button>
        </div>
      )}

      {photos.length > 0 ? (
        <Gallery
          key={photos.length} // 强制重新渲染，解决部署后缓存
          photos={photos}
          onClick={openLightbox}
          columns={({ width }) => {
            if (width < 768) return 1;
            if (width < 1366) return 2;
            return 3;
          }}
          margin={10}
          className="personal-gallery"
        />
      ) : (
        <div style={{ textAlign: "center", padding: "50px", fontFamily: "华文细黑" }}>
          No images in Personal category
        </div>
      )}

      <ModalGateway>
        {viewerIsOpen ? (
          <Modal onClose={closeLightbox}>
            <Carousel
              currentIndex={currentImage}
              views={photos.map(x => ({
                src: x.src,
                width: x.width,
                height: x.height,
                caption: x.title
              }))}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    </div>
  );
}